import { message } from 'antd';
import { WalletClient } from '../../../generated/mlmbox/client/finance/wallet.client';
import {
    CardUpdateInfoRequest,
    CreateRequest,
    ReviewRequest,
} from '../../../generated/mlmbox/client/gift_shop/gift_shop';
import { GiftShop_Info } from '../../../generated/mlmbox/types/gift_shop';
import { transport } from '../../../utils/constants';
import { getToken, isRpcError } from '../../../utils/helper';
import { giftShopClient } from './config';
import { t } from 'i18next';
import { sendError } from '../../utils/send-error';
const walletClient = new WalletClient(transport);

export async function getCard(id: number): Promise<GiftShop_Info | null> {
    try {
        const { response } = await giftShopClient.cardGet({ id }, { meta: { authorization: getToken() } });

        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function createCard(values: CreateRequest): Promise<GiftShop_Info | null> {
    try {
        const { response } = await giftShopClient.cardCreate(values, { meta: { authorization: getToken() } });

        return response;
    } catch (error) {
        console.log(error);
        if (isRpcError(error)) {
            switch (error.message) {
                //INVALID_ARGUMENT
                case 'GIFT_SHOP_CARD_PHOTO_WRONG_FORMAT':
                    message.error('Некорректный формат фотографии');
                    break;
                case 'GIFT_SHOP_CARD_PHOTO_UNKNOWN':
                    message.error('Неизвестная фотография');
                    break;
                case 'GIFT_SHOP_CARD_DETAILS_WRONG':
                    message.error('Неверные данные карточки');
                    break;
                case 'GIFT_SHOP_CARD_AMOUNT_WRONG_VALUE':
                    message.error('Некорректное значение суммы');
                    break;
                case 'GIFT_SHOP_CARD_PHOTO_WRONG_SIZE':
                    message.error(' Некорректный размер фотографии');
                    break;
                //PERMISSION_DENIED
                case 'ACCESS_TOKEN_PERMISSION_DENIED':
                    message.error('Пользователь забанен');
                    break;
                case 'ACCOUNT_NOT_FOUND':
                    message.error('Учётная запись не найдена');
                    break;
                //RESOURCE_EXHAUSTED
                case 'RESOURCE_EXHAUSTED':
                    message.error('Превышен лимит запросов');
                    break;
                default:
                    message.error('Ошибка редактирования');
                    break;
            }
        }
        return null;
    }
}

export async function updateCard(values: CardUpdateInfoRequest): Promise<GiftShop_Info | null> {
    try {
        const { response } = await giftShopClient.cardUpdate(values, { meta: { authorization: getToken() } });

        return response;
    } catch (error) {
        console.log(error);

        if (isRpcError(error)) {
            switch (error?.message) {
                //INVALID_ARGUMENT
                case 'GIFT_SHOP_CARD_PHOTO_WRONG_FORMAT':
                    message.error('Некорректный формат фотографии');
                    break;
                case 'GIFT_SHOP_CARD_UNKNOWN':
                    message.error('Неизвестная карточка');
                    break;
                case 'GIFT_SHOP_CARD_DETAILS_WRONG':
                    message.error('Неверные данные карточки');
                    break;
                case 'GIFT_SHOP_CARD_AMOUNT_WRONG_VALUE':
                    message.error('Некорректное значение суммы');
                    break;
                case 'GIFT_SHOP_CARD_PHOTO_WRONG_SIZE':
                    message.error(' Некорректный размер фотографии');
                    break;
                //PERMISSION_DENIED
                case 'ACCESS_TOKEN_PERMISSION_DENIED':
                    message.error('Пользователь забанен');
                    break;
                case 'GIFT_SHOP_CARD_NOT_ACCESS':
                    message.error('Нет доступа к карточке');
                    break;
                case 'GIFT_SHOP_CARD_MODIFY_NOT_ACCESS':
                    message.error('Нет доступа для изменения карточки');
                    break;
                //RESOURCE_EXHAUSTED
                case 'RESOURCE_EXHAUSTED':
                    message.error('Превышен лимит запросов');
                    break;
                //NOT_FOUND
                case 'GIFT_SHOP_CARD_NOT_FOUND':
                    message.error('Карточка не найдена');
                    break;
                default:
                    message.error('Ошибка редактирования');
                    break;
            }
        }

        return null;
    }
}

export async function removeCard(id: number): Promise<true | null> {
    try {
        const { response } = await giftShopClient.cardRemove({ id }, { meta: { authorization: getToken() } });

        return true;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function reviewCard(values: ReviewRequest): Promise<GiftShop_Info | null> {
    try {
        const { response } = await giftShopClient.review(values, { meta: { authorization: getToken() } });

        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function cardBuy(values: { id: number; address: string }): Promise<GiftShop_Info | null> {
    try {
        const validAddress = await walletClient.validateAddress(
            { address: values.address, processingId: 1 },
            { meta: { authorization: getToken() } }
        );

        if (!validAddress.response.validated) {
            message.error(t('errors.address'));
            sendError({ address: values?.address, cardId: values?.id }, `#err Не верный адрес (совмещенный)`);
            return null;
        }

        const { response } = await giftShopClient.cardBuy({ id: values.id }, { meta: { authorization: getToken() } });

        if (!response) {
            message.error('Ошибка при выводе');
            sendError(
                { address: values?.address, cardId: values?.id },
                `#err Попытка покупки карточки в магазине подарков`
            );
            return null;
        }

        const status = await giftShopClient.withdrawal(
            { address: values.address, cardId: values.id },
            { meta: { authorization: getToken() } }
        );

        return status.response;
    } catch (error) {
        if (isRpcError(error)) {
            sendError(
                { address: values?.address, cardId: values?.id },
                `#err Попытка вывода баллов с карточки в магазине подарков (совмещенный)`
            );
            console.log(error);
            if (error?.message) {
                switch (error.message) {
                    case 'ACCESS_TOKEN_PERMISSION_DENIED':
                        message.error('Блокировка');
                        break;
                    case 'GIFT_SHOP_CARD_NOT_ACCESS':
                        message.error('Нет доступа к карточке');
                        break;
                    case 'GIFT_SHOP_CARD_ALREADY_BOUGHT':
                        message.error('Карточка уже куплена');
                        break;
                    case 'GIFT_SHOP_CARD_BALANCE_NOT_ENOUGH':
                        message.error('Недостаточно средств');
                        break;
                    case 'GIFT_SHOP_CARD_NOT_FOUND':
                        message.error('Карточка не найдена');
                        break;
                    default:
                        message.error('Ошибка покупки');
                        break;
                }
            }
        }
        return null;
    }
}

export async function cardWithdDraw(values: { id: number; address: string }): Promise<GiftShop_Info | null> {
    try {
        const validAddress = await walletClient.validateAddress(
            { address: values.address, processingId: 1 },
            { meta: { authorization: getToken() } }
        );

        if (!validAddress.response.validated) {
            message.error(t('errors.address'));
            sendError({ address: values?.address, cardId: values?.id }, `#err Не верный адрес ()`);
            return null;
        }

        const status = await giftShopClient.withdrawal(
            { address: values.address, cardId: values.id },
            { meta: { authorization: getToken() } }
        );

        return status.response;
    } catch (error) {
        if (isRpcError(error)) {
            sendError(
                { address: values?.address, cardId: values?.id },
                `#err Попытка вывода баллов с карточки в магазине подарков`
            );
            console.log(error);
            if (error?.message) {
                switch (error.message) {
                    case 'ACCESS_TOKEN_PERMISSION_DENIED':
                        message.error('Блокировка');
                        break;
                    case 'GIFT_SHOP_CARD_NOT_ACCESS':
                        message.error('Нет доступа к карточке');
                        break;
                    case 'GIFT_SHOP_CARD_ALREADY_BOUGHT':
                        message.error('Карточка уже куплена');
                        break;
                    case 'GIFT_SHOP_CARD_BALANCE_NOT_ENOUGH':
                        message.error('Недостаточно средств');
                        break;
                    case 'GIFT_SHOP_CARD_NOT_FOUND':
                        message.error('Карточка не найдена');
                        break;
                    case 'RESOURCE_EXHAUSTED':
                        message.error('Превышен лимит запросов');
                        break;
                    case 'PROCESSING_NOT_AVAILABLE':
                        message.error('Процессинг недоступен');
                        break;
                    case 'GIFT_SHOP_CARD_NOT_BOUGHT':
                        message.error('Карточка не куплена');
                        break;
                    case 'GIFT_SHOP_CARD_REVIEW_NEED':
                        message.error('Требуется оставить отзыв перед выводом');
                        break;
                    case 'GIFT_SHOP_CARD_ALREADY_WITHDRAWAL':
                        message.error('Средства уже были выведены');
                        break;
                    case 'GIFT_SHOP_CARD_UNKNOWN':
                        message.error('Неизвестная карточка');
                        break;
                    case 'PROCESSING_ADDRESS_WRONG':
                        message.error('Некорректный адрес для вывода');
                        break;
                    case 'INTERNAL_DECODING':
                        message.error('Ошибка декодирования');
                        break;
                    case 'INTERNAL_DATABASE_ERROR':
                        message.error('Ошибка базы данных');
                        break;
                    case 'UNAUTHENTICATED':
                        message.error('UNAUTHENTICATED');
                        break;
                    case 'NOT_FOUND':
                        message.error('NOT_FOUND');
                        break;
                    default:
                        message.error('Ошибка покупки');
                        break;
                }
            }
        }
        return null;
    }
}
